import { localStorageColorSchemeManager } from '@mantine/core';

export const colorSchemeManager = localStorageColorSchemeManager({
  key: 'theme',
});
